import { useCallback, useSyncExternalStore } from "react";

// The one sidebar (AppSidebar) is open until the person closes it. The key
// is new, so a section sidebar closed before does not close this one.
const STORAGE_KEY = "bastion.sidebar.isOpen";

const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) {
    l();
  }
}

function getSnapshot(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
}

function getServerSnapshot(): boolean {
  return true;
}

function subscribe(onStoreChange: () => void) {
  listeners.add(onStoreChange);
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY || event.key === null) {
      onStoreChange();
    }
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(onStoreChange);
    window.removeEventListener("storage", onStorage);
  };
}

function persistOpen(open: boolean) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, open ? "true" : "false");
  } catch {
    // ignore
  }
  emit();
}

export function useSecondarySidebar() {
  const isOpen = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const open = useCallback(() => {
    persistOpen(true);
  }, []);

  const close = useCallback(() => {
    persistOpen(false);
  }, []);

  const toggle = useCallback(() => {
    persistOpen(!getSnapshot());
  }, []);

  return { isOpen, open, close, toggle };
}
